export default {
  apiKey: "AIzaSyAAs4qqdQbm60A4wRTLqU1pyHzyYzNF5Es",
  authDomain: "newdata-ec176.firebaseapp.com",
  databaseURL: "https://newdata-ec176.firebaseio.com",
  projectId: "newdata-ec176",
  storageBucket: "newdata-ec176.appspot.com",
  messagingSenderId: "514762108536",
  appId: "1:514762108536:web:c240a6564f39707591478d",
  measurementId: "G-XF8Q055Y89"
};
